/** @format */

export const DESKTOP_EXTRA_SMALL = '576px';
export const DESKTOP_SMALL = '700px';
export const DESKTOP_SMALL_PLUS = '900px';
export const DESKTOP_MEDIUM = '1170px';
export const DESKTOP_LARGE = '1250px';
export const DESKTOP_HUGE = '1400px';
